import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconSend = memo(({ color = '#545454', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        d="M1.11 8.756L16.447.152a1 1 0 011.457 1.125L16.337 7.26a3 3 0 01-2.902 2.24H7.5a1 1 0 000 2h5.935a3 3 0 012.902 2.24l1.567 5.983a1 1 0 01-1.457 1.125L1.109 12.244a1.999 1.999 0 010-3.488z"
        fill={color}
        fillRule="evenodd"
      />
    </Svg>
  );
});
